// extracted by mini-css-extract-plugin
export var circle = "_2v-2";
export var icon = "_2v-a";
export var iconHighlight = "_2v-0";
export var lg = "_2v-8";
export var md = "_2v-7";
export var outline = "_2v-4";
export var sm = "_2v-6";
export var square = "_2v-1";
export var xl = "_2v-9";
export var xs = "_2v-5";
export var xxs = "_2v-3";